"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendAnalytics = sendAnalytics;

var _locationHelper = require("./helpers/locationHelper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// e.g. sendAnalytics('Simple', 'Registration', 'Completed', { Location: "Homepage" })
function sendAnalytics(adjective, noun, pastTenseVerb, eventParameters) {
  if (typeof window.dataLayer === "undefined") {
    throw new Error("The GTM Data Layer object must exist on the page to call SendAnalytics");
  }

  if (typeof window.amplitude === "undefined") {
    throw new Error("The Amplitude object must exist on the page to call SendAnalytics");
  }

  if (!noun) {
    throw new Error("You must call sendAnalytics with a noun");
  }

  if (!pastTenseVerb) {
    throw new Error("You must call sendAnalytics with a past tense verb");
  }

  window.dataLayer.push({
    event: "genericevent",
    category: noun,
    action: pastTenseVerb,
    label: adjective
  });
  var eventName = adjective ? "".concat(adjective, " ").concat(noun, " ").concat(pastTenseVerb) : "".concat(noun, " ").concat(pastTenseVerb);

  if (window.gtag) {
    window.gtag('event', eventName, _objectSpread(_objectSpread({}, eventParameters), {}, {
      CurrentPath: (0, _locationHelper.getPathname)()
    }));
  }

  window.amplitude.getInstance().logEvent(eventName, _objectSpread(_objectSpread({}, eventParameters), {}, {
    CurrentPath: (0, _locationHelper.getPathname)()
  }));
}